import React from 'react';
import { useTranslation } from 'react-i18next';
import IMAGES from '../../../Constants/Images.constants';
import { Typography } from '../../../UIKit';
import { onboardingPage } from '../IOnboardingData.model';
import { OnboardingSplashStyles } from './';
import { OnboardingSlider } from '../OnboardingSlider';

const BackgroundImage = {
  [onboardingPage.STUDIO]: IMAGES.ONBOARDING.person_1,
  [onboardingPage.USC]: IMAGES.ONBOARDING.usc,
  [onboardingPage.DETAILS]: IMAGES.ONBOARDING.person_2,
  [onboardingPage.VERIFY_EMAIL]: IMAGES.ONBOARDING.person_1,
};

export const OnboardingSideSplash = ({ pageName }: { pageName: onboardingPage }) => {
  const { t } = useTranslation();
  const { classes } = OnboardingSplashStyles();
  return pageName === 'usc' ? (
    <div className={classes.onboardingSplashContainer}>
      <div className={classes.onbordingInnerContainer}>
        <img className={classes.onboardingStudioSplashImageUsc} src={BackgroundImage[pageName]} />
      </div>
    </div>
  ) : (
    <div className={classes.onboardingSplashContainer}>
      <div className={classes.onboardingStudioSplashHeader}>
        <Typography className={classes.onboardingStudioSplashTitle}>
          {t('onboarding.studio.splash.title')}
        </Typography>
        <div>
          <img className={classes.onboardingStudioSplashLogo} src={IMAGES.BRAND.LOGO_WHITE} />
        </div>
      </div>
      <OnboardingSlider pageName={pageName} />
      <img className={classes.onboardingStudioSplashImage} src={BackgroundImage[pageName]} />
    </div>
  );
};
